// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_9f9","cls2":"RecommendedPodcastBadge-cls2_3TK RecommendedPodcastBadge-cls1_9f9"};